import React from 'react';
import ReactDom from 'react-dom';

import App from './src/components/App.js';
import theme from './src/theme.js';

ReactDom.render(<App theme={theme}/>, document.getElementById("app"));
